import { render, staticRenderFns } from "./ShowCustomerNotes.vue?vue&type=template&id=254741a1&scoped=true"
import script from "./ShowCustomerNotes.vue?vue&type=script&lang=js"
export * from "./ShowCustomerNotes.vue?vue&type=script&lang=js"
import style0 from "./ShowCustomerNotes.vue?vue&type=style&index=0&id=254741a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254741a1",
  null
  
)

export default component.exports